import { t } from 'localization/utils/t';

const TP = 'paymentVerifications.enums.paymentVerificationsFaqEnums';

export const FAQ_TRANSACTION = 'G* GOATXXX#';

export const FAQ_STATEMENT_CODE = '12345';

export const FAQ_Q_HOW = {
  value: t(`${TP}.qHow`, 'How do I find my statement code?'),
  TK: 'qHow',
  TP,
};

export const FAQ_A_HOW = {
  value: t(
    `${TP}.aHow`,
    'Please log in to your online bank or credit card account and search for the GOAT transaction. There you will find a five-digit code after the hashtag at the end of the descriptor. It should look something like this:',
  ),
  TK: 'aHow',
  TP,
};

export const FAQ_A_HOW_EXPAND = {
  value: t(
    `${TP}.aHowExpand`,
    'You may need to expand the transaction details to see the full code.',
  ),
  TK: 'aHowExpand',
  TP,
};

export const FAQ_A_WHY = {
  value: t(
    `${TP}.aWhy`,
    'It is our goal to process your order as quickly as possible. When an order is submitted, some orders are placed in review status while our payments team reviews the purchase activity for any potential fraudulent activity to protect both the buyer and seller. In order to process your order, we need a little more information from you.',
  ),
  TK: 'aWhy',
  TP,
};

export const FAQ_Q_WHY = {
  value: t(`${TP}.qWhy`, 'Why do we need your statement code?'),
  TK: 'qWhy',
  TP,
};

export const FAQ_Q_WHAT = {
  value: t(`${TP}.qWhat`, "What if I can't find the code?"),
  TK: 'qWhat',
  TP,
};

export const FAQ_A_WHAT = {
  value: t(
    `${TP}.aWhat`,
    "If you're having trouble finding the code, it's possible that the code is not visible yet or you're not seeing all five digits. You can reply to the original verification request email and we can assist you.",
  ),
  TK: 'aWhat',
  TP,
};
